var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "skill" },
      [
        _c(
          "div",
          { staticClass: "form-group skill__header" },
          [
            _c("c-switcher", {
              attrs: { label: "Иностранный язык" },
              model: {
                value: _vm.form.language.show,
                callback: function ($$v) {
                  _vm.$set(_vm.form.language, "show", $$v)
                },
                expression: "form.language.show",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.form.language.show
            ? _c("div", { staticClass: "skill__config" }, [
                _c(
                  "div",
                  { staticClass: "form-group skill_required" },
                  [
                    _c("c-switcher", {
                      attrs: { type: "checkbox", label: "Обязательное" },
                      model: {
                        value: _vm.form.language.required,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.language, "required", $$v)
                        },
                        expression: "form.language.required",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "skill__params" }, [
                  _c(
                    "div",
                    { staticClass: "skill-param" },
                    [
                      _c("div", { staticClass: "skill-param__name" }, [
                        _vm._v("Параметр Иностранный язык"),
                      ]),
                      _c("list-params", {
                        attrs: {
                          form: _vm.form.language.param,
                          "field-name": "Иностранный язык",
                          "field-type": _vm.fieldType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("editDictionary", "languages")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "skill-param" },
                    [
                      _c("div", { staticClass: "skill-param__name" }, [
                        _vm._v("Параметр Уровень"),
                      ]),
                      _c("list-params", {
                        attrs: {
                          form: _vm.form.language.level,
                          "field-name": "Уровень владения",
                          "field-type": _vm.fieldType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("editDictionary", "languageLevels")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "skill" },
      [
        _c(
          "div",
          { staticClass: "form-group skill__header" },
          [
            _c("c-switcher", {
              attrs: { label: "Программа" },
              model: {
                value: _vm.form.program.show,
                callback: function ($$v) {
                  _vm.$set(_vm.form.program, "show", $$v)
                },
                expression: "form.program.show",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.form.program.show
            ? _c("div", { staticClass: "skill__config" }, [
                _c(
                  "div",
                  { staticClass: "form-group skill_required" },
                  [
                    _c("c-switcher", {
                      attrs: { type: "checkbox", label: "Обязательное" },
                      model: {
                        value: _vm.form.program.required,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.program, "required", $$v)
                        },
                        expression: "form.program.required",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "skill__params" }, [
                  _c(
                    "div",
                    { staticClass: "skill-param" },
                    [
                      _c("div", { staticClass: "skill-param__name" }, [
                        _vm._v("Параметр Программа"),
                      ]),
                      _c("list-params", {
                        attrs: {
                          form: _vm.form.program.param,
                          "field-name": "Программа",
                          "field-type": _vm.fieldType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("editDictionary", "programs")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "skill-param" },
                    [
                      _c("div", { staticClass: "skill-param__name" }, [
                        _vm._v("Параметр Уровень"),
                      ]),
                      _c("list-params", {
                        attrs: {
                          form: _vm.form.program.level,
                          "field-name": "Уровень владения",
                          "field-type": _vm.fieldType,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("editDictionary", "programLevels")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }